import apiClient from './api.client';

const CouponService = {
  list: async (accountId) => {
    const res = await apiClient.get('/coupons', { params: { accountId } });
    return res.data;
  },

  create: async (data, accountId) => {
    const res = await apiClient.post('/coupons', data, { params: { accountId } });
    return res.data;
  },

  update: async (id, data, accountId) => {
    const res = await apiClient.patch(`/coupons/${id}`, data, { params: { accountId } });
    return res.data;
  },

  remove: async (id, accountId) => {
    const res = await apiClient.delete(`/coupons/${id}`, { params: { accountId } });
    return res.data;
  },

  validate: async ({ code, subtotalCents, accountId, menuCode }) => {
    const res = await apiClient.post('/coupons/validate', {
      code,
      subtotalCents,
      accountId,
      menuCode,
    });
    return res.data;
  },
};

export default CouponService;
